module.exports = __webpack_public_path__ + "static/media/logo-left.35e2987c.png";